export default {
  tabs: {
    resources: 'Resources',
    commissions: 'Commissions',
    members: 'Staff members',
    shifts: 'Shifts',
  },
  'all-staffers': 'All staffers',
  'select-staffer': 'Select staffer',
  commission: 'Commission',
  'default-commissions': 'Default Commissions',
  'assign-commission': 'Assign commission to',
  'select-provider': 'Select provider',
  'service-provider': 'Service provider',
  seller: 'Seller',
  'show-calendar': 'Show calendar',
  'services': 'Services',
  'working-hours': 'Working hours',
  'edit-services': 'Edit services',
  products: 'Products',
  'gift-cards': 'Gift Cards',
  memberships: 'Memberships',
  packages: 'Packages',
  'add-new-text': "You're about to add a new staffer to your business. Your total subscription cost will be {totalPrice} per month (applied from the next billing cycle). Are you sure, you want to continue?",
  'add-new-cost': 'Additional staffer will cost you',
  'per-month': 'Per month',
  'break': 'Break',
  'filters': 'Filters',
  'filters-all': 'All',
  'filters-bookable': 'Bookable online',
  'assign-services': 'Assign services',
  'assign-services-staffers': 'Assign services for this Staffer to be available for booking',
  'assign-services-appliances': 'Assign services for this resource',
  'assigned-services-updated': 'Assigned services updated',
  'search-staff': 'Search Staff Members...',
  'search-appliance': 'Search Resources',
  'go-to-staffer-shifts': 'Go to staffer shifts',
  'not-working': 'Not working',
  fixed: 'Fixed',
  selected: 'Selected',
  form: {
    name: 'Name',
    'phone-number': 'Phone number',
    email: 'E-mail',
    role: 'Permission Level',
    position: 'Position',
    description: 'Staffer description',
    'choose-role': 'Permission Level',
    'basic-staffer': 'Basic Staffer',
    staffer: 'Staffer',
    receptionist: 'Reception',
    manager: 'Manager',
    owner: 'Owner',
    'appointments-and-notifications': 'Calendar & Appointments',
    'add-invite-clients': 'Add & Invite clients',
    'boost-dashboard': 'Boost Dashboard',
    'profile-completnes': 'Profile Completeness',
    'staff-management': 'Staff Management',
    sales: 'Checkout',
    clients: 'Clients Management',
    portfolio: 'Portfolio',
    marketing: 'Text and Email Marketing, Social Media Marketing, Promotions',
    'reviews-and-ratings': 'Business Portfolio, Reviews & Ratings',
    'stats-and-reports': 'Business Performance Snapshots',
    'business-profile': 'Business Profile',
    settings: 'Business Settings',
    'invite-title': 'Invite and create Booksy account?',
    'invite-subtitle': "We'll send them a link to download the Booksy app so that they can start managing their calendar.",
    'invite-pending-status': 'Invite sent on {invited}. Ask the staff member to accept it from their email or you can send it again.',
    'available-for-booking': 'Available for booking on client app',
    'add-staffer': 'Add New Staff Member',
    'edit-staffer': 'Edit Staff Member',
    save: 'Save',
    'save-and-invite': 'Save and send invite',
    add: 'Add',
    type: 'Type',
    value: 'Value',
    percentage: '% of sale',
    fixed: 'Fixed ({currency})',
    'remove-staffer': 'Remove staff member?',
    'remove-staffer-text': 'This will permanently remove {stafferName}\'s profile from your business. If they had access to your account, it will be removed.',
    'remove-staffer-confirm': 'Remove Staff Member',
    'description-hint': 'Add a short description of Staffers experience, position to let Customers better decide who to book with (optional)',
    'invite-again': 'Invite again',
    'invite-again-hint': 'Send an invitation to the staff member to give them access to their Booksy account. A message with the login details will be sent to their email address.',
    'success-add-message': 'Staff member added',
    'success-add-with-invite-message': 'Sent! We\'ve emailed your staff member instructions on how to join your team.',
    'add-and-send-invite': 'Add and send invite',
    'add-staff-member': 'Add Staff Member',
    'name-maxLength': 'This field may not be greater than {characters} characters.',
    'email-send': 'Email sent',
    'saved': 'Changes saved',
    'visible-on-calendar': 'Show Staff Member in Calendar',
    'visible-on-calendar-description': 'Check the box if the Staff Member offers services and should be visible in your Booksy Calendar.',
    'visible': 'Available for Online Booking',
    'visible-description': 'Check the box to allow clients to book services with this Staff Member online.',
    'visibility-incompatible': 'Settings not compatible. Staff Members with scheduled appointments will still be visible in the Calendar.',
    'delete-last-service-staffer': 'Remove Staff Member?',
    'delete-last-service-staffer-text': 'The services below have been assigned to this staff member only and will also be removed. Are you sure you want to remove this staff member?',
    'delete-last-service-staffer-confirm': 'Remove staff member and services',
    'combo': 'Combo',
    'modals': {
      'reassign-bookings': {
        'title': 'Reassign upcoming appointments',
        'description': 'To remove this staff member, you\'ll first need to reassign their upcoming appointments <b>({upcoming_bookings_count})</b> to a different staff member.',
        'confirm': 'Reassign appointments',
        'go-back': 'Go back',
      },
      'upcoming-bookings': {
        'title': 'Reassign appointments',
        'scheduled': '{count} appointment scheduled | {count} appointments scheduled | {count} appointments scheduled',
        'reassigned': 'All appointments reassigned',
        'reassigned-text': 'Great work! You\'re now ready to remove {stafferName}.',
      },
      'role-and-permissions': {
        'title': 'Role and permissions',
        'description': 'Select the role that best fits this staff member\'s responsibilities using the horizontal tabs below.',
        'their_permissions': 'Their permissions:',
        'no_access_to': 'Won\'t have access to:',
        'detailed_permissions': 'See detailed permissions',
        'permissions_text': 'Permissions',
        'view_only': 'View only',
        'continue_with': 'Continue with {role}',
        'permissions': {
          'personal_calendar': 'View and book on personal calendar',
          'client_contact_details': 'Client contact details',
          'all_calendars': 'Access all calendars and book for anyone',
          'checkout_and_all_transactions': 'Complete checkouts and view all transactions',
          'add_edit_client_details': 'Add and edit client details',
          'gift_cards': 'View available and purchased gift cards',
          'portfolio_and_reviews': 'Design marketplace portfolio and answer reviews',
          'create_marketing_campaigns_no_boost': 'Create marketing campaigns (excluding Boost promotions)',
          'resources': 'View all staff and resources',
          'manage_gift_cards_bundles_inventory': 'Manage gift cards, bundled services, inventory',
          'resources_shifts_commissions': 'Manage staff and resources, shifts, and commissions',
          'boost_profile_promotion': 'Manage Boost profile promotion',
          'security_and_subscription': 'Security options, account subscription (Owner only)',
          'manage_gift_cards': 'Manage gift cards',
          'manage_bundled_services_inventory': 'Manage bundled services, inventory',
          'create_marketing_campaigns': 'Create marketing campaigns',
          'checkout_options': 'Administer checkout options',
          'manage_resources': 'Manage staff and resources',
          'manage_shifts_commissions': 'Manage shifts and commissions',
          'manage_boost_profile_promo': 'Manage Boost profile promotion',
          'business_settings_account_verification': 'Administer business settings and account verifications',
        },
      },
      'permission_overrides': {
        'title': 'Customize permissions',
        'description': 'Fine-tune access for this staff member with additional permissions.',
        'apply_permissions': 'Apply permissions',
        'selected_role': 'Selected role:',
        'permission': {
          'calendar_access_header': 'Calendar access',
          'calendar_access_subheader': 'Access to all staff members’ calendars',
          'calendar_access_paragraph': 'Allow viewing and managing appointments for other team members',
          'client_info_header': 'Clients data',
          'client_info_subheader': 'Visibility of client details',
          'client_info_paragraph': 'Grant access to detailed client information and history',
          'checkout_header': 'Checkout',
          'checkout_subheader': 'Ability to checkout appointments',
          'checkout_paragraph': 'Enable processing payments and completing appointments',
        },
      },
    },
  },
  'store': {
    'visible': 'Ordering permissions',
    'visible-description': 'Allow this Staff Member to make orders in the Store.',
  },
  'appliance-form': {
    'add-appliance': 'Add New Resource',
    'edit-appliance': 'Edit Resource',
    label: 'Name',
    description: 'Description (optional)',
    'delete-appliance': 'Delete Resource',
    'delete-appliance-text': 'You are about to remove {resourceName} from your Resources.',
    'success-add-message': 'Resource added successfully',
  },
  commissions: {
    'commission-success-saved': 'Changes to Staffers commissions saved',
    'change-commission': 'Change commission',
    'load-category-default': 'Load category default',
    'clear-all-commissions': 'Clear all commissions',
    'reset-to-default-commissions': 'Restore Default Commissions',
    'commission-defaults-success': 'Changes to default commissions saved',
    'staffer-commission-defaults-success': 'Changes to Staffers commissions saved',
    'clear-all-staffers-commissions-success': 'Commissions for all Staffers were turned off',
    'clear-staffer-commissions-success': 'Commissions for this Staffer were cleared',
    'reset-to-default-commissions-success': 'Commissions for this Staffer were reset to default',
    'load-default': 'Load default',
    'clear-all-commissions-modal': {
      title: 'Clear Commissions?',
      content: 'This will clear commissions for all Staffers. <br/>Are you sure?',
      'content-staffer': 'This will clear all commissions for {stafferName}. <br/>Are you sure?',
      'btn-confirm': 'Clear Commissions',
    },
    'reset-to-default-commissions-modal': {
      title: 'Restore default commissions?',
      content: 'Doing so will change all commissions for this particular staff member.',
      'btn-confirm': 'Restore Defaults',
    },
    'load-category-default-modal': {
      title: 'Load default commissions?',
      content: 'Are you sure you want to load default commissions?',
      'btn-confirm': 'Load',
    },
    services: {
      'label': 'Services',
    },
    products: {
      'label': 'Products',
    },
    memberships: {
      'label': 'Memberships',
    },
    packages: {
      'label': 'Packages',
    },
    'gift-cards': {
      'label': 'Gift Cards',
    },
  },
}
